import React, { useContext, useState, useEffect } from 'react';
import {
  VFGlobalContext,
  REMOVE_ORDER_ENTRY,
} from '@mummssoftware/global-context/VFGlobalContext';
import { OrdersGlobalContext } from '@mummssoftware/global-context';
import { CPF } from '@mummssoftware/utils/orders/orders-constants';
import {
  verifySingleFreqEditingData,
  verifySingleFreqPRNEditingData,
} from '@mummssoftware/utils/orders/orders-utils';
import { EditRowWrapper, StatementText, FieldText } from './style/WrapperDiv';
import {
  SpecificDays,
  Effective,
  Frequency,
  PlusPRN,
  RoleGroupString,
} from '../../utils/constant';
import { EditRowButtons } from './components';
import { CPFContext } from '../Context/CPFContext';
import {
  DaysOfWeekCellRenderer,
  EffectiveCellRenderer,
  FrequencyCellRenderer,
  PrnCellRenderer,
} from '../../components/sections/CellRenderer';
import { isAideOrVolunteerRoleGroup } from '../../components/cells/utils';
import { SET_EDIT_ROW_OPEN } from '../Context/constants';

export const EditRow = () => {
  const { dispatch, agEditingData } = useContext(CPFContext);
  const { VForderData, dispatchVF } = useContext(VFGlobalContext);
  const { orderType } = useContext(OrdersGlobalContext);
  const { data } = agEditingData;
  const { roleGroupId, orderEntryId } = data;
  const [isVerified, setVerified] = useState<boolean>(false);
  // only CPF not PRN
  const isCPFOrder = orderType === CPF;
  const hidePrnForRole = isAideOrVolunteerRoleGroup(roleGroupId);

  useEffect(() => {
    const entry = orderEntryId ? VForderData[orderEntryId] : null;
    if (entry) {
      if (isCPFOrder) {
        setVerified(verifySingleFreqEditingData(entry));
      } else {
        setVerified(verifySingleFreqPRNEditingData(entry));
      }
    } else {
      setVerified(false);
    }
  }, [VForderData, orderEntryId, isCPFOrder]);

  const roleName = agEditingData?.data.name;
  const onCancelClick = () => {
    dispatch({
      type: SET_EDIT_ROW_OPEN,
      payload: false,
    });
    if (orderEntryId) {
      dispatchVF({
        type: REMOVE_ORDER_ENTRY,
        payload: orderEntryId,
      });
    }
  };
  const onConfirmClick = () => {
    if (isVerified) {
      dispatch({
        type: SET_EDIT_ROW_OPEN,
        payload: false,
      });
    }
  };

  return (
    <EditRowWrapper>
      <EditRowButtons
        onCancelClick={onCancelClick}
        onConfirmClick={onConfirmClick}
        disabled={!isVerified}
      />
      <>
        <StatementText>
          <FieldText>{RoleGroupString}</FieldText>
          <FieldText>{roleName}</FieldText>
        </StatementText>

        {isCPFOrder && (
          <>
            <StatementText>
              <FieldText>{Frequency}</FieldText>
              <FrequencyCellRenderer editData={agEditingData} />
            </StatementText>
            <StatementText>
              <FieldText>{SpecificDays}</FieldText>
              <DaysOfWeekCellRenderer editData={agEditingData} />
            </StatementText>
          </>
        )}

        <StatementText>
          <FieldText>{Effective}</FieldText>
          <EffectiveCellRenderer editData={agEditingData} />
        </StatementText>
        {!hidePrnForRole && (
          <StatementText>
            <FieldText>{PlusPRN}</FieldText>
            <PrnCellRenderer editData={agEditingData} />
          </StatementText>
        )}
      </>
    </EditRowWrapper>
  );
};
